/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-04-29 13:26:13
 * @LastEditors: 刘行 liuhang@nextmar.com
 * @LastEditTime: 2025-06-10 15:10:08
 * @FilePath: /zeelool-nextjs/src/components/Coupon/couponThumbnail.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Image from '@/components/Image';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { LocaleType } from '@/utils/constants';
import { ECouponType } from '@/utils/enums/coupon';
import { EPlatform } from '@/utils/enums/platform-enum';
import { cva } from 'class-variance-authority';
import { useLocale } from 'next-intl';
import { useContext } from 'react';
import { ICouponProps } from './type';

// 基于cva根据不同的类型展示不同的样式

const containerVariants = cva(
  'w-[calc(100%-20px)]  flex flex-col items-center justify-center relative  translate-x-[10px]',
  {
    variants: {
      couponType: {
        [ECouponType.DISCOUNT]: 'bg-[#e3deff] h-[71px] sm:h-[92px]',
        [ECouponType.SHIPPING]: 'bg-[#e9ffbc] h-[87px] sm:h-[114px] ',
      },
    },
    defaultVariants: {
      couponType: ECouponType.DISCOUNT,
    },
  },
);

const infoContainerVariants = cva('text-center', {
  variants: {
    couponType: {
      [ECouponType.DISCOUNT]: '',
      [ECouponType.SHIPPING]: 'mt-12',
    },
  },
});

const titleVariants = cva(
  'text-[24px] leading-[29px] md:text-[28px] md:leading-[34px] font-bold text-center',
  {
    variants: {
      couponType: {
        [ECouponType.DISCOUNT]: 'text-primary-color font-bb',
        [ECouponType.SHIPPING]: 'text-primary-color font-bb',
      },
    },
    defaultVariants: {
      couponType: ECouponType.DISCOUNT,
    },
  },
);

const titleClass = cva('', {
  variants: {
    locale: {
      de: '',
      en: '',
      es: '',
      fr: '',
      it: '',
      pt: '',
      fi: '',
      nl: '',
    },
    device: {
      wap: '',
      pc: '',
    },
  },
  compoundVariants: [{ locale: 'de', device: 'wap', className: '!text-[18px]' }],
});

const CouponThumbnail: React.FC<ICouponProps> = ({
  id,
  disCountText,
  title,
  description,
  isStairs,
  couponType = ECouponType.DISCOUNT,
}) => {
  const isShipping = couponType === ECouponType.SHIPPING;
  const locale = useLocale();
  const { deviceType } = useContext(ResponsiveContext);

  // 确保couponType是合法的值
  const validCouponType =
    couponType === ECouponType.SHIPPING ? ECouponType.SHIPPING : ECouponType.DISCOUNT;

  // 从description中提取shippingMethod
  // 示例格式: <div id="shipping-method">${shippingMethod}</div><div class="mt-8">${validDate}</div>
  const shippingMethod = description.match(/<div id="shipping-method">(.*?)<\/div>/)?.[1];

  // 把换行符替换为空格
  const processedDisCountText = disCountText.replace(/<br\/>/g, ' ');

  const couponShippingCouponLeftImage = () => {
    if (isShipping) {
      return {
        src: `/coupon/coupon-shipping-left.svg`,
        className: 'h-[87px] sm:h-[114px]',
      };
    }

    return {
      src: `/coupon/coupon-discount-left.svg`,
      className: 'h-[71px] sm:h-[92px]',
    };
  };

  // TODO:是否过滤掉阶梯券
  if (isStairs) return;

  return (
    <div id={id.toString()} className={containerVariants({ couponType: validCouponType })}>
      {/* left */}
      <Image
        src={couponShippingCouponLeftImage().src}
        alt="coupon-shipping-left"
        width={10}
        height={92}
        className={`absolute top-0 left-[-10px] ${couponShippingCouponLeftImage().className}`}
      />

      {/* right */}
      <Image
        src={couponShippingCouponLeftImage().src}
        alt="coupon-shipping-left"
        width={10}
        height={92}
        className={`rotate-180 absolute top-0 right-[-10px] ${couponShippingCouponLeftImage().className}`}
      />

      {/* 运费券顶部标签 */}
      {isShipping && (
        <div className="absolute top-0 -translate-y-0 px-8 md:w-[156px] md:h-[28px] flex items-center justify-center">
          <Image
            src="/coupon/coupon-shipping-top.svg"
            alt="coupon-shipping-top"
            width={156}
            height={28}
            className="absolute top-0 left-0 "
          />
          <div className="relative z-10 text-primary-color text-[11px] leading-[19px] md:text-[14px]">
            {shippingMethod}
          </div>
        </div>
      )}

      {/* 主要内容 */}
      <div className={infoContainerVariants({ couponType: validCouponType })}>
        <div
          className={`${titleVariants({ couponType: validCouponType })} ${titleClass({ locale: locale as LocaleType, device: deviceType === EPlatform.WEB ? 'pc' : 'wap' })}`}
          dangerouslySetInnerHTML={{ __html: processedDisCountText }}
        />
        <p
          className="text-primary-color mt-4 text-[12px] leading-[14px] md:text-[16px] md:leading-[19px]"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </div>
    </div>
  );
};

export default CouponThumbnail;
